<template>
  <div class="digital-store">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="Digital store"></ContentHeader>
        <b-tabs card>
          <b-tab>
            <template slot="title">
              <h6><i style="opacity: 0.4" class="fas fa-shopping-cart fa-fw fa-sm"></i> Digital Store</h6>
            </template>
            <h6>Unfortunately there are currently no cool gadgets in the Digital Store. <i class="far fa-frown"></i></h6>
          </b-tab>
          <b-tab active>
            <template slot="title">
              <h6><i class="fas fa-male"></i> Dress my Lego character</h6>
            </template>
            <em>Coming soon...</em>
          </b-tab>
        </b-tabs>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import {BTabs, BTab} from 'bootstrap-vue'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    ContentHeader,
    PreContentHeader,
    'b-tabs': BTabs,
    'b-tab': BTab
  },
  data () {
    return {
      pageContent: '',
      contentReady: false,
      contentLoadError: ''
    }
  },
  created () {
    document.title = 'Digital Store - ThinkTank'
    this.contentReady = true
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/DigitalStore.vue